import { create } from 'superstruct';

import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';
import { IconListValidator } from '../validators/IconList';

export const DEFAULT_REALM = 'icon_library';

export async function fetchIconList(realm: string = DEFAULT_REALM) {
  const rows = realm === DEFAULT_REALM ? 500 : 1000;
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/search_results?selectedLibrary=${realm}&rows=${rows}&start=0`;
  const response = await get<ApiIconListResponse>(requestUrl);
  return create(response, IconListValidator);
}
